Whether this draft creates a new position profile or edits an existing one.

- `Create`: no associated `profileId`.
- `Edit`: `profileId` identifies the source/target PositionProfile.

Absent on historical drafts.
